"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _DateInput = _interopRequireDefault(require("@airasia/phoenix-components/components/DateInput"));

var _constant = require("../constant");

var _calendarheader = _interopRequireDefault(require("./calendarheader.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CalendarHeader = _styledComponents.default.div.withConfig({
  displayName: "calendarheader__CalendarHeader",
  componentId: "sc-1wlpgs9-0"
})(function (_ref) {
  var theme = _ref.theme,
      isMobile = _ref.isMobile,
      calendarHeaderWebTablet = _ref.calendarHeaderWebTablet,
      calendarHeaderShow = _ref.calendarHeaderShow,
      calendarHeaderShowWebTablet = _ref.calendarHeaderShowWebTablet;
  return "\n    display: flex;\n    flex-direction: ".concat(isMobile ? 'column' : 'row', ";\n    margin-top: ").concat(calendarHeaderWebTablet && theme.space.standard, ";\n    flex-direction: ").concat(calendarHeaderShowWebTablet && 'column', ";\n    padding: ").concat(calendarHeaderShowWebTablet && theme.space.XXXSmall, ";\n\n    ").concat(isMobile && "\n      background-color: ".concat(calendarHeaderShow ? theme.colors.greyLighter : '', ";\n      border-width: ").concat(calendarHeaderShow && '1px', ";\n      border-color: ").concat(calendarHeaderShow && theme.colors.greyLight, ";\n      padding: ").concat(calendarHeaderShow && theme.space.XXXSmall, ";\n      "), "\n  ");
});

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarheader__IconContainer",
  componentId: "sc-1wlpgs9-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return "\n    margin-left: ".concat(theme.space.normal, ";\n    padding-top: ").concat(theme.space.XSmall, ";\n    cursor: pointer;\n  ");
});

var CalendarInputContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarheader__CalendarInputContainer",
  componentId: "sc-1wlpgs9-2"
})(["border:", ";", ";display:inline-flex;flex:1;flex-direction:row;justify-content:flex-end;margin-bottom:", ";border-radius:", ";padding-bottom:", ";"], function (props) {
  return props.showborder && '1px solid #C5C9D0';
}, function (_ref3) {
  var headerInputContainerPadding = _ref3.headerInputContainerPadding;
  return "padding: ".concat(headerInputContainerPadding);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.none;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.small;
}, function (_ref6) {
  var viewport = _ref6.viewport,
      holidayMobile = _ref6.holidayMobile,
      theme = _ref6.theme;
  return viewport === _constant.MOBILE && !holidayMobile && theme && theme.space.XSmall;
});

var CalendarInputHolder = _styledComponents.default.div.withConfig({
  displayName: "calendarheader__CalendarInputHolder",
  componentId: "sc-1wlpgs9-3"
})(["display:inline-flex;flex:1;border-width:", ";border-color:", ";border-style:", ";border-top-left-radius:", ";border-bottom-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-radius:", ";margin-right:", ";", ""], function (props) {
  return props.calendarInputHolderActive && '1px';
}, function (props) {
  return props.calendarInputHolderActive && props.theme.colors.secondary;
}, function (props) {
  return props.calendarInputHolderActive && 'solid';
}, function (props) {
  return props.calendarInputHolderActiveleft && props.theme.borderRadius.small;
}, function (props) {
  return props.calendarInputHolderActiveleft && props.theme.borderRadius.small;
}, function (props) {
  return props.calendarInputHolderActiveRight && props.theme.borderRadius.small;
}, function (props) {
  return props.calendarInputHolderActiveRight && props.theme.borderRadius.small;
}, function (props) {
  return !props.calendarInputHolderActiveleft && !props.calendarInputHolderActiveRight && props.theme.borderRadius.small;
}, function (_ref7) {
  var isOnlyApplyForHotel = _ref7.isOnlyApplyForHotel,
      theme = _ref7.theme;
  return isOnlyApplyForHotel ? theme.space.medium : theme.space.none;
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return !isMobile ? "\n        & > div {\n            & > div {\n              height: 56px;\n            }\n          }\n       " : "";
});

var Divider = _styledComponents.default.div.withConfig({
  displayName: "calendarheader__Divider",
  componentId: "sc-1wlpgs9-4"
})(["width:", ";height:100%;background-color:", ";", ""], _constant.DIVIDER_WIDTH, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.greyMedium;
}, function (_ref10) {
  var isOnlyApplyForHotel = _ref10.isOnlyApplyForHotel,
      holidayMobile = _ref10.holidayMobile;
  return (isOnlyApplyForHotel || holidayMobile) && (0, _styledComponents.css)(["height:65%;margin:2.5% 0;"]);
});

var WeekContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarheader__WeekContainer",
  componentId: "sc-1wlpgs9-5"
})(["display:flex;flex-direction:row;justify-content:center;margin-top:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.XSmall;
});

var CalendarItem = _styledComponents.default.div.withConfig({
  displayName: "calendarheader__CalendarItem",
  componentId: "sc-1wlpgs9-6"
})(function (_ref12) {
  var theme = _ref12.theme;
  return "\n    display: flex;\n    flex: 1;\n    max-width: 48px;\n    justify-content: center;\n    font-size: ".concat(theme.fontSize.XSmall, ";\n    color: ").concat(theme.colors.greyDark, ";\n  ");
});

var AaCalendarHeader = function AaCalendarHeader(props) {
  var layout = props.layout,
      viewType = props.viewType,
      showCalendarModal = props.showCalendarModal,
      newInstance = props.newInstance,
      selectForDepart = props.selectForDepart,
      selectForReturn = props.selectForReturn,
      tripType = props.tripType,
      tempDepart = props.tempDepart,
      tempReturn = props.tempReturn,
      labelReturn = props.labelReturn,
      dateFormatData = props.dateFormatData,
      labelDepart = props.labelDepart,
      textDepartInputConfig = props.textDepartInputConfig,
      textReturnInputConfig = props.textReturnInputConfig,
      closeCalendarIconPressed = props.closeCalendarIconPressed,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      isSnapCalendar = props.isSnapCalendar,
      isPartialHotelCalendar = props.isPartialHotelCalendar,
      headerInputContainerPadding = props.headerInputContainerPadding,
      disableDepart = props.disableDepart,
      disableReturn = props.disableReturn,
      addCalenderIconForMobile = props.addCalenderIconForMobile,
      enableFontSizeChange = props.enableFontSizeChange,
      holidayMobile = props.holidayMobile;

  var _useState = (0, _react.useState)(_constant.WEEK_NAME),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      weekDaysNames = _useState2[0],
      setweekDaysNames = _useState2[1];

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var ondepartClicked = function ondepartClicked(event) {
    if (disableDepart) return;

    if (isPartialHotelCalendar) {
      document.querySelector('#partialHotel-departclick-handle').focus();
    } else {
      document.querySelector('#departclick-handle').focus();
    }

    textDepartInputConfig.controls.onInputFocus(event);
  };

  var onreturnClicked = function onreturnClicked(event) {
    if (disableReturn) return;

    if (isPartialHotelCalendar) {
      document.querySelector('#partialHotel-returnclick-handle').focus();
    } else {
      document.querySelector('#returnclick-handle').focus();
    }

    textReturnInputConfig.controls.onInputFocus(event);
  };

  var addIcon = function addIcon() {
    if (holidayMobile) {
      return _constant.DATERANGE_ICON;
    }

    if ((viewType === _constant.MOBILE || isSnapCalendar) && !addCalenderIconForMobile) {
      return '';
    }

    return _constant.DATERANGE_ICON;
  };
  /**
   * Create new array of weekdays names when `dataFormatDate` is change
   */


  (0, _react.useEffect)(function () {
    if (!dateFormatData) {
      return;
    }

    var day = dateFormatData.letterDaysTranslation;
    var weekDayName = [day.sun, day.mon, day.tue, day.wed, day.thu, day.fri, day.sat];
    setweekDaysNames(weekDayName);
  }, [dateFormatData]);
  return /*#__PURE__*/_react.default.createElement(CalendarHeader, {
    id: isPartialHotelCalendar && 'aaPartialHotelCalendar-header' || 'aaCalendar-header',
    calendarHeaderWebTablet: layout && layout.isTablet,
    calendarHeaderShow: showCalendarModal,
    calendarHeaderShowWebTablet: showCalendarModal && layout && layout.isTablet,
    isMobile: viewType === _constant.MOBILE,
    addCalenderIconForMobile: addCalenderIconForMobile,
    enableFontSizeChange: enableFontSizeChange
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement(CalendarInputContainer, {
    viewport: viewType,
    holidayMobile: holidayMobile,
    id: isPartialHotelCalendar && 'partialHotelDateinputn' || 'dateinputn',
    showborder: !showCalendarModal,
    headerInputContainerPadding: headerInputContainerPadding,
    addCalenderIconForMobile: addCalenderIconForMobile,
    enableFontSizeChange: enableFontSizeChange
  }, /*#__PURE__*/_react.default.createElement(CalendarInputHolder, {
    id: isPartialHotelCalendar && 'partialHotel-departclick-handle' || 'departclick-handle',
    onClick: ondepartClicked,
    onFocus: ondepartClicked,
    calendarInputHolderActive: showCalendarModal && selectForDepart,
    calendarInputHolderActiveleft: tripType === _constant.CALENDAR_TRIP_TYPE.RETURN && newInstance && showCalendarModal && selectForDepart,
    isMobile: viewType === _constant.MOBILE,
    addCalenderIconForMobile: addCalenderIconForMobile,
    enableFontSizeChange: enableFontSizeChange
  }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
    variableWidth: viewType === _constant.MOBILE || holidayMobile,
    iconFront: addIcon(),
    hideBorder: !showCalendarModal || showCalendarModal && selectForDepart,
    dateObj: tempDepart,
    shortDaysTranslation: dateFormatData.shortDaysTranslation,
    label: labelDepart,
    dateFormat: dateFormatData.date.general,
    value: textDepartInputConfig.controls.value // onFocus={textDepartInputConfig.controls.onInputFocus}
    ,
    onChange: textDepartInputConfig.controls.updateMasterState,
    labelMarginBottomLarge: !isOnlyApplyForHotel,
    isOnlyApplyForHotel: isOnlyApplyForHotel || isSnapCalendar,
    borderRadius: themeContext && isOnlyApplyForHotel && "".concat(themeContext.borderRadius.small, " 0 0 ").concat(themeContext.borderRadius.small),
    containerBoxSizing: "content-box",
    disabled: disableDepart,
    addCalenderIconForMobile: addCalenderIconForMobile,
    enableFontSizeChange: enableFontSizeChange
  })), tripType === _constant.CALENDAR_TRIP_TYPE.RETURN ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !showCalendarModal && (viewType !== _constant.MOBILE || holidayMobile) && /*#__PURE__*/_react.default.createElement(Divider, {
    isOnlyApplyForHotel: isOnlyApplyForHotel,
    holidayMobile: holidayMobile
  }), /*#__PURE__*/_react.default.createElement(CalendarInputHolder, {
    id: isPartialHotelCalendar && 'partialHotel-returnclick-handle' || 'returnclick-handle',
    onClick: onreturnClicked,
    onFocus: onreturnClicked,
    calendarInputHolderActive: showCalendarModal && selectForReturn,
    calendarInputHolderActiveRight: showCalendarModal && selectForReturn,
    isMobile: viewType === _constant.MOBILE
  }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
    variableWidth: viewType === _constant.MOBILE || holidayMobile,
    hideBorder: !showCalendarModal || showCalendarModal && selectForReturn,
    dateObj: tempReturn,
    shortDaysTranslation: dateFormatData.shortDaysTranslation,
    label: labelReturn,
    dateFormat: dateFormatData.date.general,
    value: textReturnInputConfig.controls.value // onFocus={textReturnInputConfig.controls.onInputFocus}
    ,
    onChange: textReturnInputConfig.controls.updateMasterState,
    labelMarginBottomLarge: !isOnlyApplyForHotel,
    alignContentRight: viewType === _constant.MOBILE && !showCalendarModal && !holidayMobile,
    isOnlyApplyForHotel: isOnlyApplyForHotel || isSnapCalendar,
    borderRadius: themeContext && isOnlyApplyForHotel && "0 ".concat(themeContext.borderRadius.small, " ").concat(themeContext.borderRadius.small, " 0"),
    containerBoxSizing: "content-box",
    disabled: disableReturn,
    addCalenderIconForMobile: addCalenderIconForMobile,
    enableFontSizeChange: enableFontSizeChange
  }))) : null), showCalendarModal && viewType === _constant.MOBILE && /*#__PURE__*/_react.default.createElement(IconContainer, {
    id: isPartialHotelCalendar && 'partialHotelCloseIcon' || 'closeIcon',
    onClick: function onClick() {
      return closeCalendarIconPressed();
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "CloseIcon",
    fontsize: "titleSmall",
    color: "greyDark",
    accessible: false
  }))), showCalendarModal && viewType === _constant.MOBILE && /*#__PURE__*/_react.default.createElement(WeekContainer, null, weekDaysNames.map(function (day, index) {
    return /*#__PURE__*/_react.default.createElement(CalendarItem, {
      key: "".concat(_constant.WEEKDAY_KEYS[index]),
      calendarItem: true
    }, day);
  })));
};

AaCalendarHeader.propTypes = _calendarheader.default.PropTypes;
var _default = AaCalendarHeader;
exports.default = _default;